import React, { useState, useEffect } from "react";
import { FaRegCopy } from "react-icons/fa";

export const PendingStart = () => {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false);
    }, 800);
  }, []);
  return (
    <>
      {pageLoading ? (
        <span className="DishKiChampionsTrophy-loader"></span>
      ) : (
        <div className="winner-container centerElement">
          <div className="winner-header">
            <div className="winner-icon">
              <img src="/Images/try-agian.png" alt="Happy" />
            </div>
            {/* <h2 className="question-title">We'll be starting shortly...</h2> */}
            <p>We'll be starting shortly...</p>
          </div>
        </div>
      )}
    </>
  );
};
